import fetchData from '../../../../mixins/apiHelpers'

export default {
  data() {
    return {
      statistics: null,
      options: {
        loaded: false
      }
    }
  },
  methods: {
    fetchStatistics() {
      return new Promise((resolve) => {
        this.options.loaded = false
        this.error = null

        const id = this?.entity?.id || this.$route.params.draft_id
        const event_id = this?.entity?.event_id || this.$route.params.main_event_id

        if (!id) {
          this.error = 'ID is missing'
          this.options.loaded = true
          resolve()
          return
        }

        const endpoint =
          this.entity.model === 'event'
            ? `/leaders/events/${event_id}/statistics`
            : `/leaders/drafts/${id}/statistics`

        fetchData(`${this.$api}${endpoint}`, (response) => {
          this.statistics = response.data.data
          resolve()
        }, this)
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/views/Leaders/Listing/mixins/getStatistics.js